var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.334 22.6667L12.0007 22.6667",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.334 17.3335L17.334 17.3335",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.334 18.6668C27.334 23.6951 27.334 26.2093 25.6743 27.7714C24.0145 29.3335 21.3432 29.3335 16.0007 29.3335H14.9703C10.6221 29.3335 8.44794 29.3335 6.93808 28.2697C6.50548 27.9649 6.12143 27.6035 5.79759 27.1963C4.66732 25.7753 4.66732 23.729 4.66732 19.6365V16.2426C4.66732 12.2917 4.66732 10.3162 5.29257 8.7385C6.29774 6.20206 8.4235 4.20134 11.1185 3.2553C12.7948 2.66683 14.8937 2.66683 19.0916 2.66683C21.4903 2.66683 22.6897 2.66683 23.6476 3.0031C25.1876 3.54369 26.4023 4.68696 26.9767 6.13635C27.334 7.03792 27.334 8.16675 27.334 10.4244V18.6668Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 16C4.66667 13.5454 6.65651 11.5556 9.11111 11.5556C9.99882 11.5556 11.0454 11.7111 11.9085 11.4798C12.6754 11.2744 13.2744 10.6754 13.4798 9.90849C13.7111 9.04538 13.5556 7.99882 13.5556 7.11111C13.5556 4.65651 15.5454 2.66667 18 2.66667",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.73f67f4148d71572ea649595523ff340.svg";
export { ForwardRef as ReactComponent };